import { Locale } from "@divespots/contracts";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router";
import { App } from "./App.tsx";
import { installAnalytics } from "./analytics.ts";
import { createQueryClient } from "./api/index.ts";
import { i18n } from "./i18n/index.ts";
import { installAppHeight } from "./layout/app-height.ts";
import "./styles.css";

// Start in the language of the URL so a deep link such as /fr/spot/enteneck never flashes German.
const first = window.location.pathname.split("/")[1];
const initial = Locale.safeParse(first);
if (initial.success) void i18n.changeLanguage(initial.data);

installAppHeight();
installAnalytics();

const queryClient = createQueryClient();

// The service worker (offline use, installable app) runs in production builds only; the fixtures
// and live e2e suites build with VITE_SW=off so their requests never touch a cache.
if (import.meta.env.PROD && import.meta.env.VITE_SW !== "off" && "serviceWorker" in navigator) {
  void import("./pwa/register.ts").then((m) => m.registerServiceWorker());
}
// A data router (not <BrowserRouter>): the admin forms block navigation while edits are unsaved.
const router = createBrowserRouter([{ path: "*", element: <App /> }]);

createRoot(document.getElementById("root") as HTMLElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
